<template>
    <div>
        <heading size="medium">Send A Job Sheet</heading>
        <p class="mb-2">A job sheet will be sent to the number you enter below.</p>


        <div class="flex-1 border-l border-r border-gray-200 px-0 py-0">
            <job-sheet-contact-search
                class="col-span-full"
                #default="{ open, query, setQuery }"
                @selected:contact="contactSelected"
                :top="true"
            >
                <input
                    placeholder="Mobile Number, eg 07804557849"
                    type="text"
                    ref="number"
                    name="number"
                    v-model="number"
                    @input="setQuery($event.target.value)"
                    @focus="setQuery($event.target.value);open();"
                />
            </job-sheet-contact-search>

        </div>
        <textarea class="p-2 mb-4" v-model="message" @keydown.enter="sendSms()" name="message"
                  placeholder="Enter a message for the receiving person."></textarea>
        <crud-errors class="mb-4" :errors="errors"></crud-errors>
        <ui-button colour="green" @click.prevent="sendSms()">Send Job Sheet</ui-button>
    </div>
</template>

<script>
import AutoresizableTextarea from "../../ui/AutoresizableTextarea";
import JobSheetContactSearch from "./JobSheetContactSearch.vue";
import RoutePlanAddressSearch from "../../logistics/route-plans/RoutePlanAddressSearch.vue";

export default {
    components: {RoutePlanAddressSearch, JobSheetContactSearch},
    data() {
        return {
            number: '',
            message: '',
            errors: null
        }
    },
    props: ['jsUrl'],
    computed: {},
    watch: {},
    methods: {
        resetErrors() {
            this.errors = null;
        },
        sendSms() {
            let that = this;
            axios.request({
                method: 'post',
                url: this.jsUrl,
                data: {
                    number: this.number,
                    message: this.message
                }
            }).then(response => {

                that.number = '';
                that.message = '';
            }).catch(function (error) {
                if (error.response.status === 422) {
                    that.errors = error.response.data.errors;
                }
            });
        },
        contactSelected(contact) {
            this.number = contact.phone;
        }
    },
    mounted() {
        let that = this;
        window.eventBus.$on('crud-errors-dismissed', function () {
            that.errors = null;
        });
    }
}
</script>

<style lang="scss" scoped>
.submit {
    margin-top: 10px;
    display: inline-block;
    color: #FFF;
    background-color: $brand;
    padding: 0.5em;
    border-radius: $standardBorderRadius;
    text-decoration: none;

    &:hover {
        background-color: lighten($brand, 10);
    }
}
</style>
